import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { Split } from "./Split";
export var Destroy = /*#__PURE__*/function () {
  function Destroy() {
    _classCallCheck(this, Destroy);
    this.mode = "none";
    this.split = new Split();
  }
  _createClass(Destroy, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.mode !== undefined) {
        this.mode = data.mode;
      }
      this.split.load(data.split);
    }
  }]);
  return Destroy;
}();